var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mt-auto" }, [
    _vm.pltService
      ? _c("div", { staticClass: "d-md-flex d-none justify-content-center" }, [
          _c("div", { staticClass: "brand-section-body-item" }, [
            _c("div", { staticClass: "brand-section-body-item_logo" }, [
              _c("img", {
                staticStyle: { width: "55px", height: "55px" },
                attrs: {
                  src: _vm.platformLogos[_vm.pltService],
                  alt: _vm.pltService + " logo"
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "brand-section-body-item_intro" }, [
              _c(
                "span",
                {
                  staticClass: "font-weight-bold",
                  staticStyle: { "font-size": "1.1em" }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t(_vm.pltService + "_name")) +
                      "\n        "
                  )
                ]
              ),
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t(_vm.pltService + "_slogan")) +
                  "\n      "
              )
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        class: [
          "mt-3 mt-md-auto mx-auto w-100 border p-3 p-md-4",
          { "text-right rtl": _vm.$i18n.locale !== "en" }
        ],
        staticStyle: { "max-width": "500px" }
      },
      [
        _c(
          "div",
          { staticClass: "d-flex justify-content-center align-items-center" },
          [
            _vm.pltService && _vm.platformLogos[_vm.pltService]
              ? _c(
                  "div",
                  {
                    staticClass: "brand-section-body-item_logo d-md-none ml-3",
                    staticStyle: { padding: "5px" }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: _vm.platformLogos[_vm.pltService],
                        alt: _vm.pltService + " logo"
                      }
                    })
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "h1",
              {
                staticClass: "mb-4 text-center",
                staticStyle: { color: "#555" }
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "form-header",
                    staticStyle: { "font-size": "55%" }
                  },
                  [
                    _c("span", [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("signup")) +
                          "\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.pltService && _vm.platformLogos[_vm.pltService]
                      ? _c(
                          "span",
                          {
                            staticClass: "d-md-none",
                            staticStyle: { "font-weight": "normal" }
                          },
                          [
                            _vm._v(
                              "\n            در " +
                                _vm._s(_vm.$t(_vm.pltService + "_name")) +
                                "\n          "
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "form",
          {
            ref: "form",
            staticClass: "d-flex justify-content-center flex-column",
            attrs: {
              method: "POST",
              autocomplete: "off",
              action: _vm.urls.signup + _vm.queryParams
            }
          },
          [
            _c(
              "a",
              {
                staticClass: "google_btn mb-1",
                attrs: {
                  href: _vm.urls.googleLogin,
                  "data-gtm-name": "login_google_register"
                }
              },
              [
                _c("div", { staticClass: "label" }, [
                  _vm._v(_vm._s(_vm.$t("google_signup")))
                ]),
                _vm._v(" "),
                _vm._m(0)
              ]
            ),
            _vm._v(" "),
            _vm.$i18n.locale !== "fa"
              ? _c(
                  "a",
                  {
                    staticClass: "facebook_btn mb-1 mt-3",
                    attrs: { href: _vm.urls.facebookLogin }
                  },
                  [
                    _c("div", { staticClass: "label" }, [
                      _vm._v(_vm._s(_vm.$t("facebook_signup")))
                    ]),
                    _vm._v(" "),
                    _vm._m(1)
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "divider mb-1" }, [
              _c("div", { staticClass: "text text-center" }, [
                _vm._v(_vm._s(_vm.$t("or")))
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex flex-wrap mx-n1" },
              [
                _c("field-input", {
                  ref: "first_name",
                  staticClass: "px-sm-1 w-sm-50 w-100 mb-3",
                  attrs: {
                    type: "text",
                    name: "first_name",
                    "autocomplete-off": "",
                    label: _vm.$t("first_name"),
                    "no-trim": "",
                    "server-error": _vm.serverError.first_name,
                    rules: [
                      _vm.vRules.required(
                        _vm.$t("validation_message.firstName_is_required")
                      )
                    ],
                    "data-gtm-name": "login_register_name"
                  },
                  model: {
                    value: _vm.first_name,
                    callback: function($$v) {
                      _vm.first_name = $$v
                    },
                    expression: "first_name"
                  }
                }),
                _vm._v(" "),
                _c("field-input", {
                  ref: "last_name",
                  staticClass: "px-sm-1 w-sm-50 w-100 mb-3",
                  attrs: {
                    type: "text",
                    name: "last_name",
                    "autocomplete-off": "",
                    label: _vm.$t("last_name"),
                    "no-trim": "",
                    "server-error": _vm.serverError.last_name,
                    rules: [
                      _vm.vRules.required(
                        _vm.$t("validation_message.lastName_is_required")
                      )
                    ],
                    "data-gtm-name": "login_register_last_name"
                  },
                  model: {
                    value: _vm.last_name,
                    callback: function($$v) {
                      _vm.last_name = $$v
                    },
                    expression: "last_name"
                  }
                }),
                _vm._v(" "),
                _c("field-input", {
                  ref: "email",
                  staticClass: "px-sm-1 w-sm-50 w-100 mb-3",
                  attrs: {
                    type: "text",
                    name: "email",
                    label: _vm.$t("email"),
                    "autocomplete-off": "",
                    "input-class": "ltr",
                    "server-error": _vm.serverError.email,
                    rules: [
                      _vm.vRules.required(
                        _vm.$t("validation_message.email_is_required")
                      ),
                      _vm.vRules.email()
                    ],
                    "data-gtm-name": "login_register_email"
                  },
                  model: {
                    value: _vm.email,
                    callback: function($$v) {
                      _vm.email = $$v
                    },
                    expression: "email"
                  }
                }),
                _vm._v(" "),
                _c("field-input", {
                  ref: "phone",
                  staticClass: "px-sm-1 w-sm-50 w-100 mb-3",
                  attrs: {
                    type: "tel",
                    name: "phone",
                    label: _vm.$t("mobile_number"),
                    "autocomplete-off": "",
                    "input-class": "ltr",
                    number: "",
                    "server-error": _vm.serverError.phone,
                    rules: [
                      _vm.vRules.required(
                        _vm.$t("validation_message.phone_is_required")
                      ),
                      _vm.vRules.phone()
                    ],
                    "data-gtm-name": "login_register_phone"
                  },
                  model: {
                    value: _vm.phone,
                    callback: function($$v) {
                      _vm.phone = $$v
                    },
                    expression: "phone"
                  }
                }),
                _vm._v(" "),
                _c("field-input", {
                  ref: "password1",
                  staticClass: "px-sm-1 w-sm-50 w-100 mb-3",
                  attrs: {
                    id: "password1_input",
                    type: "password",
                    name: "password1",
                    label: _vm.$t("password"),
                    "autocomplete-off": "",
                    "input-class": "ltr",
                    "server-error": _vm.serverError.password1,
                    rules: [
                      _vm.vRules.required(
                        _vm.$t("validation_message.password_is_required")
                      ),
                      _vm.vRules.password()
                    ],
                    "data-gtm-name": "login_register_password"
                  },
                  model: {
                    value: _vm.password1,
                    callback: function($$v) {
                      _vm.password1 = $$v
                    },
                    expression: "password1"
                  }
                }),
                _vm._v(" "),
                _c("field-input", {
                  ref: "password2",
                  staticClass: "px-sm-1 w-sm-50 w-100 mb-3",
                  attrs: {
                    id: "password2_input",
                    type: "password",
                    name: "password2",
                    "autocomplete-off": "",
                    label: _vm.$t("password_repeat"),
                    "input-class": "ltr",
                    "server-error": _vm.serverError.password2,
                    rules: [
                      _vm.vRules.required(
                        _vm.$t("validation_message.password_repeat_is_required")
                      ),
                      _vm.vRules.password_repeat(_vm.password1)
                    ],
                    "data-gtm-name": "login_register_repeat_password"
                  },
                  model: {
                    value: _vm.password2,
                    callback: function($$v) {
                      _vm.password2 = $$v
                    },
                    expression: "password2"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("input", {
              attrs: { type: "hidden", name: "csrfmiddlewaretoken" },
              domProps: { value: _vm.csrfToken }
            }),
            _vm._v(" "),
            _vm.redirectFieldValue
              ? _c("input", {
                  attrs: { type: "hidden", name: _vm.redirectFieldName },
                  domProps: { value: _vm.redirectFieldValue }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.serverError.nonFieldErrors
              ? _c("div", { staticClass: "mt-0 error-text text-center mb-4" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.serverError.nonFieldErrors) +
                      "\n      "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "auth-btn btn btn-primary my-2",
                attrs: {
                  type: "submit",
                  "data-gtm-name": "login_register_register"
                }
              },
              [_vm._v("\n        " + _vm._s(_vm.$t("signup")) + "\n      ")]
            ),
            _vm._v(" "),
            _vm.$i18n.locale === "fa"
              ? _c(
                  "div",
                  {
                    staticClass: "policy mb-4 text-right rtl",
                    staticStyle: { color: "#444" }
                  },
                  [
                    _vm._v("\n        با ثبت نام در یکتانت ، شما با\n        "),
                    _c(
                      "a",
                      {
                        staticClass: "link",
                        attrs: {
                          href:
                            "https://accounts-cdn.yektanet.com/static/terms/privacy-policy.pdf",
                          target: "_blank",
                          "data-gtm-name": "login_google_privacy"
                        }
                      },
                      [
                        _vm._v(
                          "\n          شرایط رازداری و حفظ حریم خصوصی\n        "
                        )
                      ]
                    ),
                    _vm._v("\n        و\n        "),
                    _c(
                      "a",
                      {
                        staticClass: "link",
                        attrs: {
                          href:
                            "https://accounts-cdn.yektanet.com/static/terms/terms-of-services.pdf",
                          target: "_blank",
                          "data-gtm-name": "login_google_terms_of_service"
                        }
                      },
                      [_vm._v("\n          شرایط استفاده از خدمات\n        ")]
                    ),
                    _vm._v("\n        موافقت می‌کنید.\n      ")
                  ]
                )
              : _c(
                  "div",
                  {
                    staticClass: "policy mb-4",
                    staticStyle: { color: "#444" }
                  },
                  [
                    _vm._v(
                      "\n        By clicking Sign Up, you agree to our\n        "
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "link",
                        attrs: {
                          href:
                            "https://accounts-cdn.yektanet.com/static/terms/privacy-policy.pdf",
                          target: "_blank"
                        }
                      },
                      [_vm._v("\n          Terms\n        ")]
                    ),
                    _vm._v("\n        and\n        "),
                    _c(
                      "a",
                      {
                        staticClass: "link",
                        attrs: {
                          href:
                            "https://accounts-cdn.yektanet.com/static/terms/terms-of-services.pdf",
                          target: "_blank"
                        }
                      },
                      [_vm._v("\n          Data Policy\n        ")]
                    ),
                    _vm._v(
                      "\n        . You may receive SMS Notifications from us and can opt out any time.\n      "
                    )
                  ]
                ),
            _vm._v(" "),
            _c("div", [
              _c("span", { staticStyle: { color: "#444" } }, [
                _vm._v(_vm._s(_vm.$t("already_have_an_account")))
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "link",
                  attrs: {
                    href: _vm.loginUrl,
                    "data-gtm-name": "login_register_enter_account"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("login_to_account")))]
              )
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-container" }, [
      _c("span", { staticClass: "icon" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-container" }, [
      _c("span", { staticClass: "icon" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }